import DocumentTitle from "react-document-title";

import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';

export function EmailNotification(){
    return(
        <DocumentTitle title='Adamo'>
            <Container className="justify-content-md-center p-2 bg-light border">
                <Image src="images/adamo_logo.png" rounded></Image> <br/> <br/>
                <p className="text-start">Levelet küldtünk az Ön által megadott email címre, melyben elhelyeztünk egy linket. Erre kattintva megerősíti, hogy a megadott email cím az Ön tulajdonában áll, s mi tovább irányítjuk fizetési szolgáltatónk felületére, ahol lehetősége nyílik kiegyenlíteni az ADAMO előfizetési díját.</p>
                <p className="text-start">A link megnyitására 8 óra áll rendelkezésére, utána a link érvénytelenné válik!</p>
                <p className="text-start">Ezt az oldalt most nyugodtan bezárhatja.</p>
                <br/>
                <p className="text-end fw-bold">Az Adamo csapata</p>
            </Container>
        </DocumentTitle>
    )
}
